import React from 'react'
import './styles.scss'

const formatDate = {
  de: (datestring: string) => {
    return new Date(Date.parse(datestring)).toLocaleDateString('de-DE', {
      day: 'numeric',
      month: 'long'
    })
  },
  fr: (datestring: string) => {
    return new Date(Date.parse(datestring)).toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long'
    })
  }
}

export const CountSeparator = ({
  content,
  locale
}: {
  content: { separator: number; date: string }
  locale: { text: string; lang: languages }
}) => {
  const { separator, date } = content

  return (
    <div className='CountSeparator'>
      {separator} {locale.text}{' '}
      {formatDate[locale.lang](
        new Date(date) > new Date()
          ? new Date().toISOString().split('T')[0]
          : date
      )}
    </div>
  )
}
